/**
 * Factory: gridState
 */
angular.module('acme.common.factory.gridState', [])
.factory('GridStateFactory', [ function() {


  function GridState() {

    return {

      constructor: GridState,

      gridState: {
        page: 1,
        pageSize: 50,
        sortField: 'createdOn',
        sortDirection: 'desc',
        search: '',
        totalItems: 0
      },

      init: function() {
        this.gridState = {
          page: 1,
          pageSize: 50,
          sortField: 'createdOn',
          sortDirection: 'desc',
          search: '',
          totalItems: 0
        };
      },

      /**
       *
       * Builds datasource object
       *  - First fn builds any required gridState config.
       *  - Second is the Api call.
       *  - Third is success function.
       *    successFn requires both response
       * and params args.
       * @param custom {function}
       * @param api call {function}
       * @param success callback {function}
       * @returns {*}
       */
      buildDataSource: function (customFn, apiCall, successFn) {
        var r = null;

        if (typeof (customFn && apiCall && successFn) === "function") {
          r = {
            rowCount: -1,
            pageSize: this.getPropertyValue('pageSize'),
            getRows: function (params) {
              var props = customFn(params);
              apiCall(props).then(function (response) {
                successFn(response, params);
              });
            }
          };
        }
        return r;
      },

      getGridState: function () {
        return this.gridState;
      },

      setGridState: function (gridState) {
        this.gridState = gridState;
      },

      getPropertyValue: function (property) {
        return this.gridState[property];
      },

      setPropertyValue: function (property, value) {
        this.gridState[property] = value;
      },

      /**
       * 
       * @param {Partial<{
       *   page: number;
       *   pageSize: number;
       *   sortField: string;
       *   sortDirection: string;
       *   search: string;
       *   totalItems: number;
       * } | number | undefined>} pageOrProps
       * @param {number | undefined} pageSize
       * @param {string | undefined} sortField
       * @param {string | undefined} sortDirection
       * @param {string | undefined} search
       * @param {number | undefined} totalItems
       * @returns {void}
       */
      updateGridState: function (pageOrProps, pageSize, sortField, sortDirection, search, totalItems) {
        var props = pageOrProps != null && typeof pageOrProps === 'object' ? pageOrProps : {
          page: pageOrProps,
          pageSize: pageSize,
          sortField: sortField,
          sortDirection: sortDirection,
          search: search,
          totalItems: totalItems,
        }
        
        if (props.page) {
          this.setPropertyValue('page', props.page);
        }

        if (props.pageSize) {
          this.setPropertyValue('pageSize', props.pageSize);
        }

        if (props.sortField) {
          this.setPropertyValue('sortField', props.sortField);
        }

        if (props.sortDirection) {
          this.setPropertyValue('sortDirection', props.sortDirection);
        }

        if (props.search) {
          this.setPropertyValue('search', props.search);
        }

        if (props.totalItems) {
          this.setPropertyValue('totalItems', props.totalItems);
        }
      },

      resetGridState: function () {
        this.gridState = {
          page: 1,
          pageSize: 50,
          sortField: 'createdOn',
          sortDirection: 'desc',
          search: '',
          totalItems: 0
        };
      },

      applyPreferences: function(config) {
        if (config) {
          this.processSortPreferences(config.sortField, config.sortDirection, config.columns);
          this.processPaginationPreferences(config.pageSize, config.pageSizes);
        }
      },

      processPaginationPreferences: function(pageSize, pageSizes) {
        if(pageSize && !isNaN(parseInt(pageSize, 10)) && (pageSizes.indexOf(pageSize) > -1)) {
          this.gridState.pageSize = pageSize;
        }
      },

      processSortPreferences: function(sortField, sortDirection, columns) {
        if (sortField && columns instanceof Array) {
          if (columns.indexOf(sortField)) {
            this.gridState.sortField = sortField;
            this.gridState.sortDirection = this.getSortDirection(sortDirection);
          }
        }
      },

      getSortDirection: function(sortDirection) {
        var r = 'asc';
        if (sortDirection && sortDirection === 'desc') {
          r = sortDirection;
        }

        return r;
      }

    };
  }

  return GridState;

}]);
